import { Component, Input, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { BaseComponent, FileData, FileService, FileTypes, GridService, NotificationService } from 'tms-lib';
import { StoredDocuments, UploadDocument } from '../../../models';
import { StoredDocumentService } from '../../../services';

@Component({
  selector: 'app-store-documents',
  templateUrl: './store-documents.component.html',
  styleUrl: './store-documents.component.scss',
})
export class StoreDocumentsComponent extends BaseComponent implements OnInit {
  @Input() folder: string;
  @Input() subFolder: string;

  storedDocuments: StoredDocuments[] = [];
  additionalFields: FormlyFieldConfig[];
  dragAndDropClass = 'dropdiv-small';
  dragAndDropProgressClass = 'progress-small';

  dragAndDropText = $localize`Click HERE or drag file to add file`;
  processingText = $localize`Uploading files`;

  private uploadDocument: UploadDocument = { folderName: '', subFolderName: '', fileName: '' };
  private fileFormData: FormData;

  columnDefs: ColDef[] = [
    this.gridService.text('documentName', $localize`Document Name`),
    this.gridService.dateTime('dateStored', $localize`Date Stored`),
  ];

  constructor(
    private gridService: GridService,
    private fileService: FileService,
    private notificationService: NotificationService,
    private storedDocumentService: StoredDocumentService,
  ) {
    super();
  }

  ngOnInit() {
    this.uploadDocument.folderName = this.folder;
    this.uploadDocument.subFolderName = this.subFolder;
    this.listFiles();
  }

  refresh() {
    this.listFiles();
  }

  openDocument(row: any) {
    this.storedDocumentService.openPreview(row.fullPath);
  }

  removeDocument(model: any) {
    this.storedDocumentService.removeFile(model.fullPath).subscribe(() => {
      this.notificationService.success($localize`File removed successfully`);
      this.listFiles();
    });
  }

  save(file: FileData) {
    this.uploadDocument.fileName = file.name;

    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (
      fileType == FileTypes.jpeg ||
      fileType == FileTypes.jpg ||
      fileType == FileTypes.png ||
      fileType == FileTypes.bmp ||
      fileType == FileTypes.gif
    ) {
      this.fileFormData = this.fileService.imageToFormData(file.src);
      this.storedDocumentService.uploadImage(this.uploadDocument, this.fileFormData).subscribe((imagePath: string) => {
        this.notificationService.success($localize`File uploaded successfully`);
        setTimeout(() => this.listFiles(), 0);
      });
    } else {
      this.fileFormData = this.fileService.fileToFormData(file.src);
      this.storedDocumentService.uploadFile(this.uploadDocument, this.fileFormData).subscribe((imagePath: string) => {
        this.notificationService.success($localize`File uploaded successfully`);
        setTimeout(() => this.listFiles(), 0);
      });
    }
  }

  private listFiles() {
    this.storedDocumentService
      .listFiles(this.uploadDocument)
      .subscribe((model: StoredDocuments[]) => (this.storedDocuments = model));
  }
}
